var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as S from './CheckBox.styles';
// eslint-disable-next-line react/display-name
const CheckBox = forwardRef((_a, ref) => {
    var { text, name } = _a, props = __rest(_a, ["text", "name"]);
    return (_jsxs(S.Container, { children: [_jsx(S.CheckBox, Object.assign({ id: name, type: "checkbox", ref: ref }, props), void 0), _jsx(S.Label, Object.assign({ htmlFor: name }, { children: text }), void 0)] }, void 0));
});
export { CheckBox };
//# sourceMappingURL=CheckBox.js.map